export class UserSettings {
  Alarms?: {
    Targets?: {
      Push?: Target,
      Email?: Target
    }
  } = {
    Targets: {
      Push: {
        Enabled: false,
      },
      Email: {
        Enabled: false,
      },
    },
  };


  constructor(userSettings?: UserSettings) {
    if (userSettings) {
      this.update(userSettings);
    }
  }


  update(userSettings: UserSettings) {
    this.Alarms = userSettings.Alarms;
  }
}

export interface Target {
  Enabled: boolean;
}
